import { render, staticRenderFns } from "./addSparepart.vue?vue&type=template&id=06a40ca2&scoped=true"
import script from "./addSparepart.vue?vue&type=script&lang=js"
export * from "./addSparepart.vue?vue&type=script&lang=js"
import style0 from "./addSparepart.vue?vue&type=style&index=0&id=06a40ca2&prod&scoped=true&lang=css"
import style1 from "./addSparepart.vue?vue&type=style&index=1&id=06a40ca2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a40ca2",
  null
  
)

export default component.exports